import { styled } from '@mui/material';

import { useEffect, useState } from 'react';

import banner from '../../../../../assets/banner.png';
import bannerNoText from '../../../../../assets/banner_no_text.jpg';

const BannerImage = styled('img')({
  width: '100%',
  position: 'absolute',
  top: 0,
  left: 0,
  '@media(max-height: 430px)': {
    display: 'none',
  },
});

export const Banner = () => {
  const [breakpointQuery, setBreakpointQuery] = useState(false);

  const mediaQuery = window.matchMedia('(max-height: 650px)');

  const checkBreakpointMatch = () => {
    setBreakpointQuery(mediaQuery.matches);
  };

  useEffect(() => {
    mediaQuery.addEventListener('change', checkBreakpointMatch);

    checkBreakpointMatch();

    return () => mediaQuery.removeEventListener('change', checkBreakpointMatch);
  }, []);

  return <BannerImage src={breakpointQuery ? bannerNoText : banner} />;
};
